import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { ICountry } from '@boma/client-shared';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private base: string;
  private version: string;
  http: any;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  // TODO TAKE VARIABLE INPUTS
  public getJSON(country = null): Observable<any> {
    // Default this to country name and areas or country code and areas
    if (country === 'Zambia') {
      return this.httpClient.get('./assets/data/maps/zam-areas.json');
    } else {
      console.log('No Provincial Data Supplied');
      return of({});
    }
  }

  loadCountries() {
    return this.httpClient.get<ICountry[]>(
      `${this.base}api/v${this.version}/Countries`
    );
  }

  getCountry(countryId) {
    return this.httpClient.get<ICountry>(
      `${this.base}api/v${this.version}/Countries/${countryId}`
    );
  }

  getMobilePrefixes(): Observable<any> {
    return this.httpClient.get('./assets/data/mobile-prefix.json');
  }
}
